module.exports = __webpack_public_path__ + "02cd1e724b983a1824acf719d9346a3c.svg";